<button type="button" class="btn btn-warning" data-toggle="modal" data-target="#exampleModal" data-whatever="@mdo">訊息推播</button>

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl" >
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">訊息推播</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label custom">模板選擇</label>
                    <select class="form-control" style="width: 20%;display: inline-block;margin-right: 50px;" [(ngModel)]="push_type_select" (change)="append_text(push_type_select)">
                        <option default disabled value="-1">請選擇模板</option>
                        <option *ngFor="let item of push_type" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                </div>

                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label custom">通知方式</label>
                    <button [ngClass]="inform_method==1?'btn-success':'btn-secondary'" (click)="inform_method=1;has_sms_url=0" class="btn modalbtn" style="margin-right: 2%;">推播</button>
                    <button [ngClass]="inform_method==2?'btn-success':'btn-secondary'" (click)="inform_method=2" class="btn modalbtn" style="margin-right: 2%;">簡訊</button>  
                    <button [ngClass]="inform_method==3?'btn-success':'btn-secondary'" (click)="inform_method=3" class="btn modalbtn" style="margin-right: 2%;">推播+簡訊</button>  
                </div>
                <div class="user_edit_block form-group" *ngIf="inform_method != 2">
                    <label class="col-sm-2 col-form-label custom">標題</label>
                    <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="title">                          
                </div>
                <div class="user_edit_block form-group" style="display: flex;">
                    <label class="col-sm-2 col-form-label custom">內容</label>
                    <textarea class="form-control" style="width: 500px; height: 100px;" [(ngModel)]="content"></textarea>                         
                </div>
          
                <div class="user_edit_block form-group"  *ngIf="inform_method != 2">
                    <label class="col-sm-2 col-form-label custom">是否顯示推播圖片1</label>
                    <button [ngClass]="show_popup==0?'btn-success':'btn-secondary'" (click)="show_popup=0" class="btn modalbtn" style="margin-right: 2%;">否</button>        
                    <button [ngClass]="show_popup==1?'btn-success':'btn-secondary'" (click)="show_popup=1" class="btn modalbtn" style="margin-right: 2%;">是</button>  
                </div>
          
                <div *ngIf="show_popup==1 && inform_method != 2"  class="user_edit_block form-group" style="display: flex;">
                    <label class="col-sm-2 col-form-label custom">推播圖片1</label>
                    <app-img-cropper [editData]="tmp_img_b64" (imageUpload)="handleImageUpload($event,0)"></app-img-cropper>
                </div>  
              
                <div class="user_edit_block form-group"  *ngIf="inform_method != 2">
                    <label class="col-sm-2 col-form-label custom">是否顯示推播圖片2</label>
                    <button [ngClass]="show_popup1==0?'btn-success':'btn-secondary'" (click)="show_popup1=0" class="btn modalbtn" style="margin-right: 2%;">否</button>        
                    <button [ngClass]="show_popup1==1?'btn-success':'btn-secondary'" (click)="show_popup1=1" class="btn modalbtn" style="margin-right: 2%;">是</button>  
                </div>
          
                <div *ngIf="show_popup1==1 && inform_method != 2"  class="user_edit_block form-group" style="display: flex;">
                    <label class="col-sm-2 col-form-label custom">推播圖片2</label>
                    <app-img-cropper [editData]="tmp_img_b641" (imageUpload)="handleImageUpload($event,1)"></app-img-cropper>
                </div>  

                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">APP導入頁面</label>
                    <select class="form-control" style="width: 20%;display: inline-block;margin-right: 50px;" [(ngModel)]="addroute_sign">
                        <option default disabled value="-1">請選擇APP導入頁面</option>
                        <option *ngFor="let item of route_sign" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                </div>

                <div class="user_edit_block form-group" style="display: flex;">
                    <label class="col-sm-2 col-form-label custom">備註</label>
                    <textarea class="form-control" style="width: 500px; height: 100px;" [(ngModel)]="memo"></textarea>                         
                </div>
              
                <div class="user_edit_block form-group">
                    <label  class="col-sm-2 col-form-label custom"  for="datetime">發送時間</label>
                    <input type="datetime-local" id="datetime" name="datetime"  [(ngModel)]="selectedDateTime" required>
                </div>

                <div class="user_edit_block form-group" style="display: flex;" *ngIf="inform_method != 1">
                    <label class="col-sm-2 col-form-label custom">是否代入網址</label>
                    <button [ngClass]="has_sms_url==0?'btn-success':'btn-secondary'" (click)="has_sms_url=0" class="btn modalbtn" style="margin-right: 2%;">否</button>        
                    <button [ngClass]="has_sms_url==1?'btn-success':'btn-secondary'" (click)="has_sms_url=1" class="btn modalbtn" style="margin-right: 2%;">是</button>  
                </div>

                <div class="user_edit_block form-group">
                    <label  class="col-sm-2 col-form-label custom"  for="datetime">已選人數：</label>
                    {{select_num}}      
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary"  [attr.data-dismiss]="(this.title != '' && this.content != '' && this.addroute_sign != '-1')? 'modal' : null"   (click)="send()">確認</button>
                <button type="button" class="btn btn-danger" data-dismiss="modal">取消</button>
            </div>
        </div>
    </div>
</div>